export enum ModerationStatus {
  HIDDEN = 3,
  DRAFT = 4,
  CLOSED = 5,
  MODERATORS_AND_AUTHORS_COMMENT = 6,
  MODERATORS_ONLY_COMMENT = 7
}
